module.exports = __webpack_public_path__ + "img/asset-01.de72d919.svg";